export default __webpack_public_path__ + "static/ProximaNova-ExtrabldIt-17c2001f5e1a3e5487db81cbe6b15bd6.woff2";